import React, { useState } from "react";
import useLocales from "../../../../../../hooks/useLocales";
import toast from "react-hot-toast";
import httpRequest from "../../../../../../axios/index";
const LangModal = ({ isOpen, onCancel, languagesShow }) => {
  const { translate } = useLocales();
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [otherLanguage, setOtherLanguage] = useState("");
  const [isButtonDisabled, setButtonDisabled] = useState(false);

  const languagesData = [
    {
      label: "عربي",
      value: "ar",
    },
    {
      label: "française",
      value: "fr",
    },
    {
      label: "中国人",
      value: "cn",
    },
  ];

  const handleRadioChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  const handleInputChange = (event) => {
    setOtherLanguage(event.target.value);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    if (selectedLanguage === "") {
      toast.error("Please Select Language");
      return;
    }

    const { userid } = JSON.parse(localStorage.getItem("user"));
    setButtonDisabled(true);
    const selectedLangObj = languagesData?.find(lang => lang.value === selectedLanguage);

    try {
      const payload = {
        userId: userid,
        label: selectedLangObj.label,
        value: selectedLanguage
      };
      const url = "/api/user/savelanguage";
      const response = await httpRequest.post(url, payload);

      const result = response?.data?.message;
      const status = response?.data?.status;

      if (status === "success") {
        toast.success(result);
        onCancel();
        setSelectedLanguage("");
        languagesShow();
      }
    } catch (error) {
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    } finally {
      setButtonDisabled(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 h-screen w-screen flex items-center justify-center">
      <div className="absolute h-screen w-screen inset-0 bg-gray-800 opacity-50"></div>
      <div
        className="bg-white dark:bg-dark-primary rounded-lg p-6"
        style={{ zIndex: 9999999 }}
      >
        <p className="text-body_copy2_black dark:text-color_v1_dark lg:text-custom_h6 mb-6">
          {translate("language_setting.more_lang_cap")}
        </p>
        <div className="gap-10 flex items-center justify-between mb-6">
          {languagesData.map((lang) => (
            <label
              key={lang.value}
              className="flex items-center space-x-2 dark:text-color_v1_dark"
            >
              <input
                type="radio"
                name="language"
                value={lang.value}
                onChange={handleRadioChange}
                checked={selectedLanguage === lang.value}
                className="w-4 h-4 accent-main_color bg-gray-100 border-gray-300 dark:bg-gray-700 dark:border-gray-600"
              />
              <span> {lang.label}</span>
            </label>
          ))}
        </div>

        <div className="mt-[10px]">
          <label htmlFor="textInput2" className="dark:text-color_v1_dark">
            {translate("language_setting.more_lang_cap")}
          </label>
          <input
            type="text"
            id="textInput2"
            name="textInput2"
            placeholder={translate("language_setting.search_other_lang")}
            className="dark:border-color_dark focus:dark:border-font_color bg-transparent mt-[10px] mb-[50px] p-[8px] lg:p-[8px] py-[2px] lg:py-[1px] px-[10px] border border-light_bg_v2 text-heading_color  dark:text-color_v1_dark text-small2 lg:text-body_copy2 rounded-md focus:outline-none block w-full placeholder-[0px] placeholder-opacity-50"
            onChange={handleInputChange}
            value={otherLanguage}
          />
        </div>

        <div className="gap-4 flex items-center justify-end mt-[80px]">
          <button
            className="dark:border-color_dark hover:dark:border-font_color rounded-full px-6 py-2 sm:text-center text-center border border-black text-small3_b text-body_copy1_color dark:text-color_v1_dark"
            onClick={onCancel}
          >
            {translate("cms.cancel")}
          </button>
          <button
            className="text-white bg-main_color rounded-full px-8 py-2 sm:text-center text-small3_b text-body_copy1_color dark:text-color_v1_dark text-center"
            type="submit"
            onClick={handleFormSubmit}
            disabled={isButtonDisabled}
          >
            {translate("biolink_title.add_cap_modal")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LangModal;